'use strict';

module.exports = {
  template: require('./performance-review-distribution.html'),
  controller: require('./performance-review-distribution.controller'),
  controllerAs: 'vm',

  bindings: {
    round: '<',
    data: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-distribution/index.js
 ** module id = 289
 ** module chunks = 0
 **/